import { t } from '@/features/i18n/utils';
import { ProcurementBreadcrumbs } from '@/features/subcontractor-bids/components/procurement-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { Icon } from '@/ui/components/icon';
import { FileCheck } from '@hugeicons-pro/core-stroke-rounded';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { procurementFindingsQuery } from '@/features/subcontractor-bids/queries';
import { ReservationsPage } from '@/features/subcontractor-bids/reservations/components/reservations-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations',
)({
  component: RouteComponent,
  loader: (opts) =>
    opts.context.queryClient.query({
      ...procurementFindingsQuery(opts.params.procurementId),
      staleTime: 'static',
    }),
  validateSearch: z.object({
    findingKey: z.string().optional(),
    subcontractorId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId"
          params={{ projectId, workspaceId, procurementId }}
        />
        <ProcurementBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={FileCheck} />
            {t({ en: 'Review reservations', nb: 'Gjennomgå forbehold' })}
          </BreadcrumbPage>
        </ProcurementBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <ReservationsPage />
    </>
  );
}
